<template>
  <div ref="optionsBox" style="position: relative">
    <div class="panel panel-success">
      <div class="panel-heading">
        Optionen
      </div>
      <div class="panel-body">
        <spinner v-if="loading"></spinner>
        <div class="row" v-if="$props.filterId && !loading">
          <div class="col-md-10">
            <input type="text" class="form-control" v-model="option" placeholder="Optionsname">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-primary form-control delete-button" @click="storeOption">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
        <div v-if="!$props.filterId">
          Optionen können erst nach dem Erstellen des Filters hinzugefügt werden.
        </div>
        <hr v-if="!loading && $props.filterId">
        <div v-for="(option, index) in options" :key="option.id" class="row padding" v-if="!loading">
          <div class="col-md-10">
            <i class="fa fa-pencil edit" @click="disabledInput(index, option)" v-if="option.disabled"></i>
            <i class="fa fa-check edit" @click="edit(index, option)" v-if="!option.disabled"></i>
            <input type="text" class="form-control" v-model="option.option" :disabled="option.disabled">
          </div>
          <div class="col-md-2">
            <button type="button" class="btn btn-danger form-control delete-button" @click="deleteOption(option.id)">
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "../../common/spinner/Spinner";

export default {
  name: 'FmuFilterOptionsBox',
  components: {Spinner},
  props: {
    filterId: {}
  },
  data() {
    return {
      option: '',
      options: [],
      loading: false
    }
  },
  mounted() {
    this.getAllOptions();
  },
  methods: {
    getAllOptions() {
      this.loading = true;
      if (this.$props.filterId) {
        axios.get(`/backend/fmu_filter_options/${this.$props.filterId}`).then((res) => {
          this.options = res.data
          this.options.map(item => item.disabled = true)
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      } else {
        this.loading = false;
      }
    },
    storeOption() {
      axios.post('/backend/fmu_filter_options', {
        filterId: this.$props.filterId,
        option: this.option
      }).then(() => {
        this.option = '';
        this.getAllOptions();
        this.$toastr.s("Option erfolgreich gespeichert", "Erfolgreich");
      }).catch(e => {
        console.log(e)
      })
    },
    deleteOption(optionId) {
      if (confirm('Bist du dir sicher?')) {
        axios.delete(`/backend/fmu_filter_options/${optionId}`).then(() => {
          this.getAllOptions();
          this.$toastr.s("Option erfolgreich gelöscht", "Erfolgreich");
        }).catch(e => {
          console.log(e)
        })
      }
    },
    disabledInput(index, option, disabled = false) {
      option.disabled = disabled;
      this.$set(this.options, index, option)
    },
    edit(index, option) {
      axios.put(`/backend/fmu_filter_options/${option.id}`, {
         option: this.options[index].option
      }).then(() => {
        this.disabledInput(index, option, true)
        this.$toastr.s("Option erfolgreich bearbeitet", "Erfolgreich");
      }).catch(e => {
        console.log(e)
      })
    }
  }
}
</script>

<style scoped>
.padding {
  padding: 5px 0
}

.edit {
  position: absolute;
  right: 25px;
  top: 10px;
  cursor: pointer;
}
</style>
